import UserAuthenticationModel from '../user/auth.js'
import get from "lodash/get"
const UserReducer = (state = UserAuthenticationModel.GetCredential(),action) => {
    switch (action.type) {
        case "CreateUserSession":
            state = {
                username: action.payload.username,
                token: action.payload.access_token,
                refresh_token: action.payload.refresh_token,
                is_auth :true,
                in_auth : false,
                props:{...state.props}
            };
            UserAuthenticationModel.WriteCredential(state)
            break;

        case "StoreUserInformation":
            state = {
                ...state,
                props:{
                  ...state.props,
                  alias        :action.payload.Alias,
                  first_name   :action.payload.FirstName,
                  last_name    :action.payload.LastName,
                  tag          :action.payload.Tag,
                  phone        :action.payload.Phone,
                  email        :action.payload.Email,
                  role         :action.payload.Role,
                  address1     :action.payload.Address,
                  address2     :action.payload.Address2,
                  city         :action.payload.City,
                  postal       :action.payload.Postal,
                  permission   :action.payload.Permission,
                  active       :action.payload.Active,
                  isAdmin      :action.payload.IsAdmin,
                  is_superuser :action.payload.is_superuser,
                  isStorage    :action.payload.IsStorage,
                  tenant       :action.payload.Tenant,
                  emailNotif   :action.payload.EmailNotif,
                  nextOfKin    :action.payload.NextOfKin,
                  phoneNo      :action.payload.PhoneNo,
                  photo        :action.payload.Photo,
                  is_lite      :get(action,"payload.tenant.is_lite",false)
                }
            };
            UserAuthenticationModel.WriteCredential(state)
            break;
        case "UpdateUserInformation":
            state = {
              ...state,
              props: {
                ...state.props,
                ...action.payload
              }
            };
            UserAuthenticationModel.WriteCredential(state)
            break;
        case "StoreUserInfoFromMobile":
            state = {
                username: action.payload.username,
                token: action.payload.token,
                refresh_token: action.payload.refreshToken,
                is_auth : true,
                in_auth : false,
                props:{
                  alias        :action.payload.props.alias,
                  first_name   :action.payload.props.firstName,
                  last_name    :action.payload.props.lastName,
                  tag          :action.payload.props.tag,
                  phone        :action.payload.props.phone,
                  email        :action.payload.props.email,
                  role         : { 
                    Alias : action.payload.props.role.alias,
                    Name  : action.payload.props.role.name
                  },
                  role_name    :action.payload.props.role.name,
                  address1     :action.payload.props.address1,
                  address2     :action.payload.props.address2,
                  city         :{
                    Name: action.payload.props.city.name,
                    pk: action.payload.props.city.alias
                  },
                  postal       :action.payload.props.postal,
                  permission   :action.payload.props.permission,
                  active       :action.payload.props.active,
                  isAdmin      :action.payload.props.isAdmin,
                  is_superuser :false,
                  isStorage    :action.payload.props.isStorage,
                  tenant       :action.payload.props.Tenant,
                  emailNotif   :action.payload.props.emailNotif,
                  nextOfKin    :action.payload.props.nextOfKin,
                  phoneNo      :action.payload.props.phoneNo,
                  photo        :action.payload.props.photo,
                  is_lite      :action.payload.props.is_lite
                }
            };
            UserAuthenticationModel.WriteCredential(state)
            break;

        case "RemoveUserSession":
            state = {
                ...state,
                username: null,
                token: null,
                refresh_token: null,
                is_auth :false,
                in_auth : false,
            };
            UserAuthenticationModel.RemoveCredential()
            break;

        case "UpdateUserSession":
          console.log("UpdateUserSession is deprecated.")
          state = {
            username      : UserAuthenticationModel.GetCredential().username,
            token         : UserAuthenticationModel.GetCredential().token,
            refresh_token : UserAuthenticationModel.GetCredential().refresh_token,
            is_auth       : true,
            in_auth       : false,
            props         : {
              email        : UserAuthenticationModel.GetCredential().email,
              first_name   : action.payload.FirstName,
              last_name    : action.payload.LastName,
              is_superuser : action.payload.is_superuser,
            }
          };
          UserAuthenticationModel.WriteCredential(state)
          break;

        case "UpdateTenantLogoLoginSession":
          state = {
            username      : UserAuthenticationModel.GetCredential().username,
            token         : UserAuthenticationModel.GetCredential().token,
            refresh_token : UserAuthenticationModel.GetCredential().refresh_token,
            is_auth       : true,
            in_auth       : false,
            // fix if logo login change, and update session prop
            // added by danan 8-april-2019
            props         : {...UserAuthenticationModel.GetCredential().props}
          };
          UserAuthenticationModel.WriteCredential(state)
          break;

        case "AuthToogle":
              state = {
                  ...state,
                  in_auth: action.payload,
              };
            break;

        default:
            break;
    }
    return state;
};

export default UserReducer;



// WEBPACK FOOTER //
// ./src/App/store/user.js